import request from './request'

export default class CommercialAgreementsApi {
  async startEaseAdditionalAgree(model) {
    model?.stages?.forEach(stage => {
      delete stage.editObject
    })


    return await request({
      environment: '/agreements',
      type: 'mutation',
      name: 'startAdditionalAgree',
      variables: {model},
      way: './graphql/agreements/mutation/',
    })
  }

  async additionalAgreeForEdit(model) {
    return await request({
      environment: '/agreements',
      type: 'query',
      name: 'additionalAgreeForEdit',
      variables: {model},
      way: './graphql/agreements/query/',
      has_catch: true
    })
  }

  async agreeHistory(model) {
    return await request({
      environment: '/agreements',
      type: 'query',
      name: 'agreeHistory',
      variables: {model},
      way: './graphql/agreements/query/',
      has_catch: true
    })
  }

  async agreeLatest(model) {
    if (!model) {
      return
    }
    return await request({
      environment: '/agreements',
      type: 'query',
      name: 'agreeLatest',
      variables: {model},
      way: './graphql/agreements/query/',
      has_catch: true
    })
  }

  async actualAgreementsByTenders(model) {
    return await request({
      environment: '/agreements',
      type: 'query',
      name: 'actualAgreementsByTenders',
      variables: {model},
      way: './graphql/agreements/query/',
      has_catch: true
    })
  }
}
